import { MenuItem } from '../navigation-template/navigation.const';

/**
 * Admin navigation menu items. Add new items here to scale the sidebar.
 * Each item can have a route (for navigation) or a handler (for actions like sign out).
 */
export type AdminMenuKey = 'organizations' | 'home' | 'sign-out';

export type AdminEntityType = 'organization';

export const AdminEntityMenuItems: MenuItem<AdminEntityType>[] = [
	{
		key: 'organization',
		icon: '@tui.building',
	},
];

export const AdminMenuItems = (): MenuItem<AdminMenuKey>[] => [
	{
		key: 'organizations',
		location: 'side',
		route: 'organizations',
		icon: '@tui.building',
	},
];
